module.exports = __webpack_public_path__ + "img/ic_sporttypes_empty.26a398a4.svg";